/* eslint-disable import/prefer-default-export */
export function trimPrismicUrl(url) {
  let newUrl = String(url);
  newUrl = newUrl.replace(/\?.+/g, '');
  // console.log(url.replace(/test/, ''));
  return `${newUrl}?auto=compress,format`;
}
